import React from "react";
import { Card, Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const Unauthorized: React.FC = () => {
  return (
    <Container className="py-5">
      <Card>
        <Card.Body className="text-center py-5">
          <h3>You don't have permission to view this page.</h3>
          <p className="mb-4">
            Release Flags administration is limited to ScopeStack site
            administrators.
          </p>
          <Link to="/">Return home</Link>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Unauthorized;
